import { ThemedText, ThemedView } from "@app/theme"
import LinearGradient from "react-native-linear-gradient";
import EndJourneyIcon from "./EndJourneyIcon"
import Button from "@app/sharedComponents/Button/Button";
import InfoIcon from "@app/assets/svg/infoIcon";
import ROUTE from "@app/navigationApp/routes";
import { getParameters } from "@app/utils";
import { useEffect, useState } from "react";
import { Platform } from "react-native";
import LogOutUser, { clearAsyncStorageExcept, deleteAllCookies } from "@app/helper/logout";
import Glow from "@app/assets/svg/Glow";
import SuccessWithCircle from "@app/assets/svg/SuccessWithCircle";
import { useTheme } from "@shopify/restyle";
import { persistor } from "@app/store/newstore";

export const EndJourney = ({
    navigation,
    route
}) => {
    const [params, setParams] = useState<any>(getParameters(window.location.href));
    const { colors } = useTheme();

    const handleContinue = () => {
        navigation.reset({
            index: 0,
            routes: [{ name: ROUTE.KYC_STEPPER }],
        });
    }

    const getParams = () => {
        const params = getParameters(window.location.href);
        setParams(params);
    }

    useEffect(() => {
        getParams();
        setTimeout(() => {
            if (Platform.OS === 'web' && params.isCustomer === 'true') {
                //add &startnew=true url without reloading the page and not removing the existing parameters
                deleteAllCookies();
                persistor.purge();
                clearAsyncStorageExcept(['first_time', 'show_new_arch', 'show_lms_revamp', 'remoteConfig', 'biometric_permission'])
                const url = window.location.href;
                const newUrl = url.split('?')[0] + '?startnew=true&' + url.split('?')[1];
                window.history.replaceState(null, '', newUrl);
            }
        }, 0);
    }, []);
    return params.isCustomer === 'true' ? (
        <LinearGradient colors={[colors['bg-fill-success'], colors['bg-surface-primary']]} style={{ flex: 1 }} key="endJourney">
            <ThemedView position={'absolute'} top={0} left={0} right={0} zIndex={-1}>
                <Glow width={'100%'} height={'100%'} />
            </ThemedView>
            <ThemedView flex={1} alignItems='center' style={{ paddingTop: 200 }}>
                <SuccessWithCircle />
                <ThemedText variant="b2s" color="text-primary" paddingBottom="sm" paddingTop='4xl'>
                    Selfie captured successfully
                </ThemedText>
                <ThemedText variant="b3m" color="text-secondary" textAlign="center">
                    Close this tab and let your partner continue the journey
                </ThemedText>
            </ThemedView>
        </LinearGradient >
    ) : (<ThemedView backgroundColor="bg-surface-primary" flex={1} padding='xl' justifyContent='center' alignItems='center' >
            <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="md" >
                <ThemedView padding='md' >
                    <EndJourneyIcon />
                    <ThemedView marginBottom='md' /> 
                    <ThemedText
                        variant="h5s"
                        color="text-primary"
                        marginBottom="lg"
                    >
                        Do you want to continue your loan application journey?
                    </ThemedText>
                    <Button
                        eventName={route.name + '_GET_MY_PORTFOLIO'}
                        label={'Continue loan application'}
                        handlePress={() => {
                            handleContinue()
                        }}
                        type={'OUTLINED'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-primary'
                        buttonLoader={false}
                    />
                </ThemedView>
                <ThemedView backgroundColor='bg-fill-emphasis-primary-1' flexDirection='row' alignItems='center' gap='sm' padding='md' borderBottomLeftRadius="md" borderBottomRightRadius="md" >
                    <InfoIcon/>
                    <ThemedText variant="b4r" color="text-secondary">
                        Close the tab if selfie verification is the only step you wanted to complete
                    </ThemedText>
                </ThemedView>
            </ThemedView>

        </ThemedView>
    )
}       